"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMAIL = void 0;
/* eslint-disable no-control-regex */
const COPY_1 = require("../messages/COPY.js");
const COPY_2 = require("../placeholders/COPY.js");
exports.EMAIL = {
    MIN_LENGTH: 3,
    // eslint-disable-next-line max-len
    PATTERN: /(maestro)|(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/u,
    PLACEHOLDER: COPY_2.PLACEHOLDERS_COPY.EMAIL,
    REQUIRED_MESSAGE: COPY_1.MESSAGES_COPY.PLEASE_ENTER_EMAIL
};
//# sourceMappingURL=EMAIL.js.map